import { ContactData } from "../../../../components/ManagementsUpdate/ManagementsUpdatePowers/ManagementsUpdateNewPowers/ManagementsUpdateNewPowers";
import { NewPowers } from "../../../../core/models/managementsUpdate/managementsUpdatePowers/managementsUpdatePowers";
import { formatDate } from "../../../dateUtils/formatDate.util";

const formatUpdatePowersRequestBody = (
  checkBoxRadioValue: string,
  appliedDay: Date | undefined,
  newPowers: NewPowers,
  notes: string,
  contactData: ContactData,
  maximeter: boolean,
): string => {
  const changedPowers = Object.entries(newPowers).map(
    ([key, value]) => ` ${key.toUpperCase()}:${value}kW`,
  );
  const appliedDayFormatted =
    checkBoxRadioValue === "asap"
      ? "Cuanto antes"
      : formatDate(appliedDay as Date);
  const contactDataText = [
    contactData.contactName.trim()
      ? `Persona de contacto: ${contactData.contactName.trim()}`
      : "",
    contactData.phone.trim()
      ? `Número de teléfono: ${contactData.phone.trim()}`
      : "",
  ]
    .filter(Boolean)
    .join("; ");

  return `Potencias solicitadas: ${changedPowers}; Fecha de aplicación: ${appliedDayFormatted}; ${
    contactDataText ? `${contactDataText}; ` : ""
  }${notes.length ? `Notas: ${notes};` : ""}maximetro: ${maximeter}`;
};

export { formatUpdatePowersRequestBody };
